import script from "./AdvertisingItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdvertisingItem.vue?vue&type=script&lang=ts&setup=true"

import "./AdvertisingItem.vue?vue&type=style&index=0&id=26ca2298&lang=scss"

const __exports__ = script;

export default __exports__